const signInFormConstantsAR = {
  signInTitle: 'تسجيل الدخول',
  emailLabel: 'البريد الإلكتروني',
  passwordLabel: 'كلمة السر',
  siginInButtonText: 'تسجيل الدخول',
  signinForgotPassword: 'هل نسيت كلمة السر ؟',
  checkboxLabel: 'تذكرني',
  siginInInvalidPassword: 'الرجاء إدخال كلمة السر الصحيحة',
  siginInInvalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
  siginInEmptyPassword: 'الرجاء إدخال كلمة المرور',
  siginInEmptyEmail: 'الرجاء إدخال البريد الإلكتروني',
  noAccount: 'ليس لديك حساب؟',
  noAccountLinkText: 'اتصل بالمسؤول',
  reCaptchaValidationError: 'فشل التحقق , الرجاء المحاولة مرة أخرى',
  reCaptchaEmptyValidation: 'التحقق إجباري',
};

export default signInFormConstantsAR;
